"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  return (0, _core.jsx)("path", {
    d: "M250 438c23 0 41.7-18.7 41.7-41.7h-83.3c-.1 23 18.6 41.7 41.6 41.7zm135.4-125H375v-83.3c0-54.7-35.2-101-84-118 .4-2.3.7-4.6.7-7 0-23-18.7-41.7-41.7-41.7s-41.7 18.7-41.7 41.7c0 2.4.3 4.7.7 7-48.9 17-84 63.3-84 118V313h-10.4c-17.3 0-31.2 14-31.2 31.2s14 31.2 31.2 31.2H385.4c17.3 0 31.2-14 31.2-31.2S402.7 313 385.4 313z"
  });
};

exports.default = _default;